// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"content-with-image-section_sectionWrapper__ettSK","sectionImage":"content-with-image-section_sectionImage__QL7BS"};